import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { DocumentTypeLevelType } from '../../models/requirement-descriptions.model';
import { RequirementOverrideDetail } from '../../models/requirement-override-detail.model';
import { SaveRequirementOverrideRequest } from '../../models/save-requirement-override-request.model';

/**
 * @deprecated Do not use this service.  Use service(s) from "src/app/compliance/api" or "src/app/compliance/api/migration"
 */
@Injectable({ providedIn: 'root' })
export class RequirementsOverrideService {
    private readonly coreApiNovaPath: string;

    constructor(
        private readonly httpClient: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiNovaPath = combine(
            settings.coreAPIUrl,
            'ayanova/compliance/requirement-qualification-setting-override/'
        );
    }

    // ** RequirementQualificationSettingOverrideController.GetRequirementOverrideDetailsAsync
    getRequirementOverrideDetail(
        documentTypeId: number,
        entityType: DocumentTypeLevelType,
        entityId: number
    ): Observable<RequirementOverrideDetail> {
        const url = combine(
            this.coreApiNovaPath,
            `${documentTypeId}/description/details?entityType=${entityType}&entityId=${entityId}`
        );
        return this.httpClient.get<RequirementOverrideDetail>(url);
    }

    // ** RequirementQualificationSettingOverrideController.SaveRequirementOverrideAsync
    saveRequirementOverride(request: SaveRequirementOverrideRequest): Observable<void> {
        const url = combine(this.coreApiNovaPath, `${request.documentTypeId}/description/details`);
        return this.httpClient.post<void>(url, request);
    }

    // ** RequirementQualificationSettingOverrideController.DeleteRequirementOverrideAsync
    deleteRequirementOverride(
        documentTypeId: number,
        entityType: DocumentTypeLevelType,
        entityId: number
    ): Observable<void> {
        const url = combine(
            this.coreApiNovaPath,
            `${documentTypeId}/description/details?entityType=${entityType}&entityId=${entityId}`
        );
        return this.httpClient.delete<void>(url);
    }
}
